module.exports = __webpack_public_path__ + "officialStatic/img/detail-diffict3.0ffa4a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-diffict3.png
// module id = AGpS
// module chunks = 0